export class launchOfferData {
    title : string = '';
    firstName: string = '';
    lastName: string = '';
    mobileNumber: string = '';
    dob : string = '';
    email: string = '';
    panNumber: string = '';
    pinCode : string = '';
    city : string = '';
    state : string = '';
    address1 : string = '';
    address2 : string = ''; 
   
    relation : string = '';
    insuredTitle : string = '';
    insuredFirstName : string = '';
    insuredLastName : string = '';
    insuredDob : string = '';
    occupation : string = '';
    nomineeName : string = '';
    nomineeRelation : string = '';

    constructor() {
    }
}